/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

function setExternalLinksToOpenInNewTab() {
  // Get all anchor tags under the header tag
  const headerLinks = document.querySelectorAll('header a');
  
  // Iterate through each link
  headerLinks.forEach(function(link) {
    // Check if the link is external
    if (link.hostname !== window.location.hostname) {
      // Set the target attribute to open in a new tab
      link.setAttribute('target', '_blank');
    }
  });
}

// Call the function to apply the changes
setExternalLinksToOpenInNewTab();


if(theme.strings){
  Shopify.Cart.ShippingCalculator.show( {
    submitButton: theme.strings.shippingCalcSubmitButton,
    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
    customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
    moneyFormat: theme.strings.shippingCalcMoneyFormat
  } );
}

